var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_35381_64643)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9941 18.9542C20.9107 18.3794 20.9519 17.7934 21.115 17.236C21.278 16.6786 21.5591 16.1627 21.9391 15.7236C22.3192 15.2844 22.7893 14.9321 23.3175 14.6906C23.8457 14.4492 24.4197 14.3242 25.0005 14.3242C25.5813 14.3242 26.1553 14.4492 26.6835 14.6906C27.2117 14.9321 27.6818 15.2844 28.0618 15.7236C28.4419 16.1627 28.7229 16.6786 28.886 17.236C29.0491 17.7934 29.0903 18.3794 29.0068 18.9542L27.6628 28.3575C27.5698 28.9972 27.2495 29.5821 26.7606 30.005C26.2718 30.4279 25.6469 30.6607 25.0005 30.6607C24.354 30.6607 23.7292 30.4279 23.2403 30.005C22.7514 29.5821 22.4312 28.9972 22.3381 28.3575L20.9941 18.9542ZM27.3338 35.3342C27.3338 35.953 27.088 36.5465 26.6504 36.9841C26.2128 37.4217 25.6193 37.6675 25.0005 37.6675C24.3816 37.6675 23.7882 37.4217 23.3506 36.9841C22.913 36.5465 22.6671 35.953 22.6671 35.3342C22.6671 34.7153 22.913 34.1219 23.3506 33.6843C23.7882 33.2467 24.3816 33.0008 25.0005 33.0008C25.6193 33.0008 26.2128 33.2467 26.6504 33.6843C27.088 34.1219 27.3338 34.7153 27.3338 35.3342Z",
    fill: "#EC3939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_35381_64643",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0509804 0 0 0 0 0.0705882 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35381_64643"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35381_64643",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportant);
export default __webpack_public_path__ + "static/media/Important.91851a0d05ddfb649812d037374afc7c.svg";
export { ForwardRef as ReactComponent };